<template>
  <div>
    <div class="popup" :style="{ top: popupVisible ? '0' : '-100%' }">
      <div class="popup-content">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <div class="tpaCombox" v-if="showOutrasFormas">
                <v-combobox v-model="tpaForma1" :rules="ruleForma1" label="Forma de pagamento (1)"
                  item-value="num_recibo" item-text="num_recibo" :items="tpaMultiplos" return-object
                  @change="selecionarTpaFormas()" rounded>
                </v-combobox>
              </div>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <div class="tpaCombox" v-if="showOutrasFormas">
                <v-combobox v-model="tpaForma2" :rules="ruleRequired" label="Forma de pagamnto (2)"
                  item-value="num_recibo" item-text="num_recibo" :items="tpaMultiplos" return-object
                  @change="selecionarTpaFormas()" rounded>
                </v-combobox>
              </div>
            </v-col>
          </v-row>
          <v-card-actions style="background-color: #fff">
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="savePaymentWay">
              Guardar
            </v-btn>
            <v-btn color="black darken-1" text @click="cancelPaymentWay">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </div>

    <div class="button-container" @click="abrirCardMaisEmolumento()">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab color="blue" style="color: white; margin-top: 5px"
            x-large><v-icon>add</v-icon></v-btn>
        </template>
        <span> Adicionar outros emolumentos </span>
      </v-tooltip>
    </div>

    <div class="combox_containers">
      <div class="tpaCombox" v-if="showDataContainer">
        <template>
          <v-menu ref="menuDataPagamento" v-model="menuDataPagamento" :close-on-content-click="false"
            transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="dataPagamentoSelected" :rules="[(v) => !!v || 'Campo obrigatório!']"
                label="Data de pagamento" prepend-icon="event" readonly v-on="on" rounded></v-text-field>
            </template>
            <v-date-picker ref="picker" max="2025-12-31" min="1950-01-01" v-model="datePagamento"
              @change="saveDatePagamento"></v-date-picker>
          </v-menu>
        </template>
      </div>
      <div class="tpaCombox">
        <v-combobox v-model="tpaSelectedField" :rules="ruleRequired" label="Forma de pagamento" item-value="num_recibo"
          item-text="num_recibo" :items="tpas" return-object @change="selecionarItem()" @click="initializeTPA()"
          rounded>
        </v-combobox>
      </div>
      <div class="tpaCombox">
        <v-combobox v-model="trimestreSeleted" :rules="ruleRequired" label="Trimestre" item-value="id"
          item-text="descricao" :items="trimestres" return-object @change="selecionarTrimestre()" rounded>
        </v-combobox>
      </div>
      <div class="tpaCombox">
        <v-combobox v-model="anolectivoSeleted" :rules="ruleRequired" label="Ano Lectivo" item-value="anolectivo"
          item-text="novadescricao" :items="Listaranoslectivo" return-object @change="selecionarAnoLectivo()" rounded>
        </v-combobox>
      </div>

    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
import utilitarios from "../../plugins/utilitarios";
const ls = require("local-storage");
export default {
  data() {
    return {
      anolectivoSeleted: null,
      Listaranoslectivo: [],
      showDataContainer: false,
      popupVisible: false,
      showOutrasFormas: false,
      menuDataPagamento: null,
      dataPagamentoSelected: null,
      datePagamento: null,
      tpas: [],
      tpaMultiplos: [],
      tpaSelectedField: null,
      tpasSelected: [],
      tpaForma1: null,
      tpaForma2: null,
      ruleRequired: [(value) => !!value || "Campo obrigatório"],
      date: null,
      trimestreSeleted: {
        id: 0,
        descricao: "Todos",
      },
      trimestres: [
        { id: 0, descricao: "Todos" },
        { id: 1, descricao: "Primeiro" },
        { id: 2, descricao: "Segundo" },
        { id: 3, descricao: "Terceiro" },
      ],
      existeForma1: true,
      valid: true,
    };
  },

  created() {
    this.initializeAnosLectivo();
    this.dataPagamentoSelected = utilitarios.ObterDataActural();
    this.$emit("dataSelected", this.dataPagamentoSelected);
    this.verificarPermissaoAlterarData();
    this.initializeTPA();
    this.selecionarItem();
  },

  computed: {
    idInstituicao() {
      return ls.get("i_id");
    },

    ruleForma1() {
      return [
        value => !!value || 'Campo obrigatório!!',
      ];
    },
    anoLectivoSistema() {
      return ls.get("anolectivo");
    }
  },

  methods: {
     async initializeAnosLectivo() {
      try {
        const response = await axios.get("/listarAnoLectivoAllFinancas");
        this.Listaranoslectivo = response.data;
        this.anolectivoSeleted = this.Listaranoslectivo.filter((a) => a.anolectivo == this.anoLectivoSistema)[0]
      } catch (error) {
         Swal.fire(
          "Informação",
          "Erro ao carregar os anos lectivos!",
          "error"
        );
      }
    },


    async verificarPermissaoAlterarData() {
      try {
        let status = await axios
          .get(`/verificarHabilitarFuncao/${1}/${this.idInstituicao}`)
          .then((res) => res.data);
        if (status.length && status[0].status === 1) {
          this.showDataContainer = true;
        } else {
          this.showDataContainer = false;
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro durante a validação da função selecionar data!",
          "error"
        );
      }
    },

    savePaymentWay() {
      this.$refs.form.validate();
      if (!this.tpaForma1) {
        this.existeForma1 = false;
        return;
      }
      this.existeForma1 = true;
      this.popupVisible = false
    },

    cancelPaymentWay() {
      this.popupVisible = false
    },


    saveDatePagamento(datePagamento) {
      this.$refs.menuDataPagamento.save(datePagamento);
      this.dataPagamentoSelected = datePagamento;
      this.date = new Date(datePagamento).toISOString().substr(0, 10);

      this.$emit("dataSelected", this.dataPagamentoSelected);
    },

    selecionarItem() {
      if (this.tpaSelectedField) {
        if (this.tpaSelectedField.formaPagamento == 1000) {
          this.popupVisible = true;
          this.showOutrasFormas = true;
        } else {
          this.showOutrasFormas = false;
        }

        this.selecionarTpaFormas();
      }
    },

    selecionarTpaFormas() {
      this.tpasSelected = [];
      if (this.showOutrasFormas && this.tpaForma1 && this.tpaForma2) {
        this.tpasSelected[0] = this.tpaForma1;
        this.tpasSelected[1] = this.tpaForma2;
      } else if (
        !this.showOutrasFormas &&
        this.tpaSelectedField.formaPagamento != 1000
      ) {
        this.tpasSelected[0] = this.tpaSelectedField;
      }

      this.$emit("itemSelected", this.tpasSelected, this.showOutrasFormas);
    },

    selecionarTrimestre() {
      this.$emit("trimestreSelected", this.trimestreSeleted);
    },

    selecionarAnoLectivo() {
      this.$emit("anoLectivoSelected", this.anolectivoSeleted);
    },

    async initializeTPA() {
      try {
        this.tpas = await axios.get("/tpasFindAll").then((res) => res.data);
        this.tpaMultiplos = this.tpas.filter((t) => t.formaPagamento != 1000);
      } catch (error) {
        console.log(error);
        
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao carregar os dados dos TPAs",
          "error"
        );
      }
    },

    abrirCardMaisEmolumento() {
      this.$emit("cardMaisEmolumento", true);
    },
  },
};
</script>

<style scoped>
.combox_containers {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 5px;
  gap: 3px;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 5px;
}

.button-container {
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
